import { render, staticRenderFns } from "./ratemanage.vue?vue&type=template&id=1083c17c&scoped=true&"
import script from "./ratemanage.vue?vue&type=script&lang=js&"
export * from "./ratemanage.vue?vue&type=script&lang=js&"
import style0 from "./ratemanage.vue?vue&type=style&index=0&id=1083c17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1083c17c",
  null
  
)

export default component.exports